import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock, Globe } from "lucide-react";
import api from "@/lib/api";
import { formatPrice } from "@/lib/format";

export default function Programs() {
  const [programs, setPrograms] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    api.get("/programs").then((r) => setPrograms(r.data));
  }, []);

  const cats = ["All", ...Array.from(new Set(programs.map((p) => p.category)))];
  const visible = filter === "All" ? programs : programs.filter((p) => p.category === filter);

  return (
    <div data-testid="programs-page" className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24">
      <div className="text-sm uppercase tracking-[0.25em] text-primary-ub">Programs</div>
      <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl mt-4 leading-[1.02] tracking-tighter">
        Choose the doorway.<br/><span className="italic text-primary-ub">Walk through.</span>
      </h1>
      <p className="mt-6 text-lg text-ub-2 max-w-2xl">
        Every program is a lived experience — designed by Anant over years of practice, teaching, and quietly listening.
      </p>
      <div className="flex flex-wrap gap-2 mt-10">
        {cats.map((c) => (
          <button
            key={c}
            onClick={() => setFilter(c)}
            data-testid={`filter-${c.toLowerCase()}`}
            className={`px-5 py-2 rounded-full text-sm border transition-colors ${
              filter === c ? "bg-ub-dark text-white border-ub-dark" : "bg-ub border-ub text-ub hover:border-[var(--ub-primary)]"
            }`}
          >
            {c}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
        {visible.map((p) => (
          <Link key={p.id} to={`/programs/${p.id}`} data-testid={`program-${p.id}`} className="group bg-ub border border-ub rounded-[2rem] p-8 hover:-translate-y-1 transition-all duration-500 hover:shadow-lg">
            <div className="flex items-start justify-between">
              <span className="text-xs uppercase tracking-widest text-primary-ub">{p.category}</span>
              <span className="text-sm text-ub-2">{p.price > 0 ? formatPrice(p.price, p.currency) : "Free / Custom"}</span>
            </div>
            <h3 className="font-serif text-3xl md:text-4xl mt-4 leading-tight">{p.title}</h3>
            <p className="text-ub-2 mt-2">{p.tagline}</p>
            <p className="text-ub-2 mt-4 leading-relaxed">{p.description}</p>
            <div className="flex items-center gap-5 mt-6 text-sm text-ub-2">
              <span className="inline-flex items-center gap-1.5"><Clock size={14} /> {p.duration}</span>
              <span className="inline-flex items-center gap-1.5"><Globe size={14} /> {p.format}</span>
            </div>
            <div className="mt-6 inline-flex items-center gap-2 text-ub group-hover:text-primary-ub transition-colors">
              Explore <ArrowRight size={16} />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
